import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import type { FarmerProfile } from "@/mocks/farmerProfiles";

export default function FarmerDetailStory({ farmer }: { farmer: FarmerProfile }) {
  return (
    <section className="sun-glaze bg-background-50 py-20 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                Their Story
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
              The Hands Behind {farmer.village}'s Fields
            </h2>

            <div className="mt-6 space-y-4">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                {farmer.intro}
              </p>
              {farmer.bio.map((paragraph) => (
                <p
                  key={paragraph}
                  className="text-sm md:text-base text-foreground-600 leading-relaxed"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="bg-secondary-50 rounded-lg border border-secondary-200 p-7 md:p-8">
              <h3 className="font-heading text-xl text-foreground-950 font-semibold">
                Known For
              </h3>
              <p className="text-sm text-foreground-600 mt-2">
                What {farmer.name} brings to every visit.
              </p>
              <ul className="mt-5 space-y-3">
                {farmer.specialties.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                      <i className="ri-leaf-line text-base"></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-800">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}